var CompositePublicKey_1, CompositePrivateKey_1;
import { __decorate } from "tslib";
import { OneAsymmetricKey } from "@peculiar/asn1-asym-key";
import { AsnArray, AsnType, AsnTypeTypes, BitString, OctetString } from "@peculiar/asn1-schema";
import { AlgorithmIdentifier, SubjectPublicKeyInfo } from "@peculiar/asn1-x509";
export const id_composite_key = "2.16.840.1.114027.80.4.1";
export const id_Dilithium3_ECDSA_P256 = "2.16.840.1.114027.80.5.1";
export const id_Dilithium3_RSA = "2.16.840.1.114027.80.5.2";
let CompositeAlgorithmIdentifier = class CompositeAlgorithmIdentifier extends AlgorithmIdentifier {
};
CompositeAlgorithmIdentifier = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence })
], CompositeAlgorithmIdentifier);
export { CompositeAlgorithmIdentifier };
let CompositePublicKey = CompositePublicKey_1 = class CompositePublicKey extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, CompositePublicKey_1.prototype);
    }
};
CompositePublicKey = CompositePublicKey_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: SubjectPublicKeyInfo })
], CompositePublicKey);
export { CompositePublicKey };
export class CompositePublicKeyOs extends OctetString {
}
export class CompositePublicKeyBs extends BitString {
}
let CompositePrivateKey = CompositePrivateKey_1 = class CompositePrivateKey extends AsnArray {
    constructor(items) {
        super(items);
        Object.setPrototypeOf(this, CompositePrivateKey_1.prototype);
    }
};
CompositePrivateKey = CompositePrivateKey_1 = __decorate([
    AsnType({ type: AsnTypeTypes.Sequence, itemType: OneAsymmetricKey })
], CompositePrivateKey);
export { CompositePrivateKey };
